export default __webpack_public_path__ + "static/media/pic4.f008bc42.jpg";